export enum Products {
  NO_APV = 'NOAPV',
  APV = 'APV',
}
